import styled from 'styled-components'

export const ModalContentWrapper = styled.div`
  max-height: 80vh;
  min-width: 355px;

  & .container {
    padding: 10px 17px;
  }
`

export const ModalTitle = styled.div`
  box-shadow: inset 0px -1px 0px ${({ theme }) => theme.colors.borderDefault};
  color: ${({ theme }) => theme.colors.textTitle};
  font-size: 15px;
  font-weight: 600;
  line-height: 24px;
  padding: 12px 0 12px;
  text-align: center;
`

export const ModalContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 80px 24px 24px 24px;

  .status-img {
    height: 64px;
    width: 64px;
  }

  p {
    margin: 19px 0 70px 0;
    text-align: center;
  }
`

const Button = styled.button`
  border-radius: 48px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  line-height: 140%;
  padding: 13px 0;
  width: 100%;
`

export const BackButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.primary};
  border: 1px solid ${({ theme }) => theme.colors.primary};
  color: #ffffff;
`

export const CancelButton = styled(Button)`
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.colors.primary};
  color: #705fc0;
`
